export function getTotalTravelDistanceKm(stops: { travelMeters?: number | null }[] | undefined): number {
  if (!stops) return 0;
  const totalMeters = stops.reduce((sum, stop) => sum + (stop.travelMeters ?? 0), 0);
  return totalMeters / 1000;
}
